module.exports = __webpack_public_path__ + "order.png?db12ccabb6336e2c027a6888630202f8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/order.png
// module id = 45
// module chunks = 0